function slideUpFaq(element, duration = 300) {
    element.style.height = element.offsetHeight + 'px';
    element.offsetHeight; // force repaint
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = 0;

    setTimeout(() => {
        element.style.display = 'none';
        element.style.removeProperty('height');
        element.style.removeProperty('transition');
    }, duration);
}
function slideDownFaq(element, duration = 300) {
    element.style.removeProperty('display');
    if (getComputedStyle(element).display === 'none') {
        element.style.display = 'block';
    }

    let height = element.scrollHeight;
    element.style.height = '0px';
    element.offsetHeight;
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = height + 'px';

    setTimeout(() => {
        element.style.removeProperty('height');
        element.style.removeProperty('transition');
    }, duration);
}
document.addEventListener("DOMContentLoaded", function () {
    const ingredientsSlider = document.querySelector('.ingredients-lists');

    let ingredientsFlkty = null;
    let vendorFlkty = null;
    let reviewFlkty = null;

    function initSliders() {
        if (window.innerWidth <= 767) {

            // Ingredients slider
            if (!ingredientsFlkty && ingredientsSlider) {
                ingredientsFlkty = new Flickity(ingredientsSlider, {
                    cellAlign: 'left',
                    contain: true,
                    wrapAround: false,
                    pageDots: true,
                    prevNextButtons: true,
                    draggable: true
                });
            }

        } else {
            // Destroy on tablet / desktop
            if (ingredientsFlkty) {
                ingredientsFlkty.destroy();
                ingredientsFlkty = null;
            }
        }

        const tabButtons = document.querySelectorAll('.customer-review-tab-button');
        const reviewContents = document.querySelectorAll('.customer-review-contents');
        const isMobile = window.matchMedia('(max-width: 767px)').matches;

        if (tabButtons && reviewContents) {
            let reviewFlktyMap = new Map();

            reviewContents.forEach(content => {
                // init Flickity per tab content
                const flkty = new Flickity(content, {
                    cellAlign: 'left',
                    contain: true,
                    wrapAround: false,
                    pageDots: true,
                    prevNextButtons: true,
                    draggable: true,
                    groupCells: isMobile ? false : 3
                });

                reviewFlktyMap.set(content.dataset.reviewTab, flkty);
            });

            tabButtons.forEach(btn => {
                btn.addEventListener('click', () => {
                    const targetTab = btn.dataset.reviewTab;

                    // Active tab button
                    tabButtons.forEach(b => b.classList.toggle('active', b === btn));

                    // Show matching content, hide others
                    reviewContents.forEach(content => {
                        const isMatch = content.dataset.reviewTab === targetTab;
                        content.classList.toggle('active', isMatch);

                        if (isMatch) {
                            if (document.querySelector('.customer-review-contents .crc-content')) {
                                document.querySelectorAll('.customer-review-contents').forEach(container => {
                                    matchHeightWithin(container, '.crc-content');
                                });
                            }
                            reviewFlktyMap.get(targetTab).resize();
                        }
                    });
                });
            });

            if (document.querySelector('.customer-review-contents .crc-content')) {
                document.querySelectorAll('.customer-review-contents').forEach(container => {
                    matchHeightWithin(container, '.crc-content');
                });
            }

        }

    }

    initSliders();
    window.addEventListener('resize', initSliders);

    function matchHeightWithin(parent, selector) {
        const elements = parent.querySelectorAll(selector);
        if (!elements.length) return;

        // reset
        elements.forEach(el => el.style.height = 'auto');

        let maxHeight = 0;
        elements.forEach(el => {
            maxHeight = Math.max(maxHeight, el.offsetHeight);
        });

        elements.forEach(el => {
            el.style.height = `${maxHeight}px`;
        });
    }

    const arrow = document.querySelector('.meals-down-arrow img');
    const target = document.querySelector('#customer-review-section') || document.querySelector(".pdp-below-the-fold-cro-fifth-section");

    if (arrow && target) {
        arrow.addEventListener('click', () => {
            const headerOffset = 100;
            const elementPosition = target.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        });
    }

    if(document.body.classList.contains('crisps')){
        let arrow = document.querySelector('.meals-down-arrow img');
        let target = document.querySelector('.pdp-fold-fifth-main-wrap');

        if (arrow && target) {
            arrow.addEventListener('click', () => {
                const headerOffset = 100;
                const elementPosition = target.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            });
        }
    }

    //  Code for close accorion start here
    const panels = document.querySelectorAll('.pdp-fold-fifth-main-wrap .faq__wrapper .accordion__panel');
    const duration = 450;

    function isVisible(el) {
        return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }

    panels.forEach(panel => {
        const btn = panel.querySelector('.accordion__btn');
        const content = panel.querySelector('.accordion__content');

        if (!btn || !content) return;

        btn.addEventListener('click', (e) => {
             e.preventDefault();
             e.stopPropagation();
            // close other open panels
            panels.forEach(otherPanel => {
                // console.log(otherPanel, "otherPanel");
                // console.log(otherPanel.classList.contains('is-active'), "otherPanel.classList.contains('is-active')");
                if (otherPanel !== panel && otherPanel.classList.contains('is-active')) {
                    const otherContent = otherPanel.querySelector('.accordion__content');
                    slideUpFaq(otherContent, duration);
                    otherPanel.classList.remove('is-active');
                }
            });

            // toggle current
            if (panel.classList.contains('is-active')) {
                slideUpFaq(content, duration);
                panel.classList.remove('is-active');
            } else {
                slideDownFaq(content, duration);
                panel.classList.add('is-active');
            }
        });
    });
});
if ($('.meal-benefit-btn').length > 0) {
    $('.pdp-fold-meal-section .meal-benefit-btn').on('click', function (e) {
        e.preventDefault();

        const pageUrl = $(this).attr('href'); // get href
        // console.log(pageUrl, "pageUrl")
        const modalEl = document.getElementById('meal-popup');
        const modalBody = $('#meal-popup .product-modal__body');

        modalBody.html('<p>Loading...</p>');

        fetch(pageUrl)
            .then(response => response.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                // adjust selector based on your page structure
                const pageContent = doc.querySelector('main') || doc.querySelector('.page-width');

                if (pageContent) {
                    modalBody.html(pageContent.innerHTML);
                } else {
                    modalBody.html('<p>Content not found.</p>');
                }

                new Modal({ el: modalEl }).show();
            });
    });
}